module.exports = __webpack_public_path__ + "img/dotselected.6e930154.png";